<div #chartContainer id="chartContainer" class="chart-container"></div>
